// Texty detailu článku — slovenské dvojče locale/cs/articleDetail.js.
export default {
  authorNote: 'Poradňa a servis náradia, Bílina',
  authorFallback: 'Redakcia Jipos',
  share: 'Zdieľať',
  shareOne: 'Zdieľať článok',
  copied: 'Odkaz skopírovaný',
  toc: 'Obsah článku',
  prev: 'Predchádzajúci',
  next: 'Nasledujúci',
  morePre: 'Ďalšie z rubriky ',
  moreAll: 'Zobraziť všetko',
  shareFb: 'Zdieľať na Facebooku',
  shareMail: 'Poslať e-mailom',
  shareCopy: 'Kopírovať odkaz',
  sharePrint: 'Vytlačiť',
};
